import { render, staticRenderFns } from "./workorder-detail-values.vue?vue&type=template&id=54f9ea57&scoped=true&"
import script from "./workorder-detail-values.vue?vue&type=script&lang=js&"
export * from "./workorder-detail-values.vue?vue&type=script&lang=js&"
import style0 from "./workorder-detail-values.vue?vue&type=style&index=0&id=54f9ea57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9ea57",
  null
  
)

export default component.exports